/* eslint-disable */
import React from 'react'
import {Icon, message} from 'antd'
import {Link} from 'react-router-dom'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import jMoment from 'moment-jalaali'
import moment from 'moment'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})

class ListShortageDriver extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      shiftDate: null,
      excel: []
    }
  }
  componentDidMount() {}

  handleDateChange = (shiftDate) => {
    this.setState({shiftDate})
  }

  epochFrom = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
  }
  epochTo = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '23:59:59'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
  }

  submit(e) {
    e.preventDefault()
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  getReport() {
    let shiftDate = this.state.shiftDate
    if (shiftDate === null) {
      message.error('تاریخ وارد شود')
    } else {
      JASPERREPORT(
        `report/supplier/driver/least-shortage?fromTime=${this.epochFrom(shiftDate)}&toTime=${this.epochTo(shiftDate)}`
      )
    }
  }

  getReportByProvider() {
    let shiftDate = this.state.shiftDate
    if (shiftDate === null) {
      message.error('تاریخ وارد شود')
    } else {
      JASPERREPORT(
        `report/supplier/driver/provider/least-shortage?fromTime=${this.epochFrom(shiftDate)}&toTime=${this.epochTo(
          shiftDate
        )}`
      )
    }
  }

  date(props) {
    return <input className="form-control" {...props} />
  }

  render() {
    return (
      <div className="rtl">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>توزیع</li>
            <li>گزارش حداقل کسری رساننده</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>گزارش حداقل کسری رساننده</p>
            </div>

            <div className="formComponent">
              <label className="font-weight-bold">
                تاریخ :<span className="requireFiled font-weight-bold">*</span>
              </label>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <DatePicker
                  inline
                  okLabel="تأیید"
                  autoOk={true}
                  leftArrowIcon={<Icon type="left" />}
                  rightArrowIcon={<Icon type="right" />}
                  cancelLabel="لغو"
                  labelFunc={(shiftDate) => (shiftDate == null ? '' : shiftDate.format('jYYYY/jM/jDD'))}
                  value={this.state.shiftDate}
                  id="date"
                  onChange={this.handleDateChange}
                  TextFieldComponent={this.date}
                  readOnly
                />
              </MuiPickersUtilsProvider>
            </div>

            <div className="formComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getReport.bind(this)}>
                گزارش حداقل کسری رساننده
              </button>
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getReportByProvider.bind(this)}>
                گزارش حداقل کسری رساننده به تفکیک تامین کننده
              </button>
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default ListShortageDriver
